<template>
  <div class="hospital-query">
    <!-- 统一查询方式：姓名+身份证+电话+验证码 -->
    <div class="query-section">
      <div class="query-section-header">
        <div class="query-section-indicator"></div>
        <h3 class="query-section-title">患者信息查询（姓名+院内预留电话+验证码）</h3>
      </div>
      
      <div class="query-form">
        <van-form @submit="onSubmitQuery" ref="queryForm">
          <van-field
            v-model="queryForm.name"
            name="name"
            label="姓名"
            placeholder="请输入就诊卡本人姓名"
            :rules="[{ required: true, message: '请输入姓名' }]"
          >
            <template #label>
              <span class="required-star">*</span>姓名
            </template>
          </van-field>
          
          <!-- <van-field
            v-model="queryForm.idCard"
            name="idCard"
            label="身份证号"
            placeholder="请输入就诊卡本人身份证号"
            maxlength="18"
            :rules="[
              { required: true, message: '请输入身份证号' },
              { 
                pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, 
                message: '请输入正确的身份证号' 
              }
            ]"
          >
            <template #label>
              <span class="required-star">*</span>身份证号
            </template>
          </van-field> -->
          
          <van-field
            v-model="queryForm.phone"
            name="phone"
            type="tel"
            label="手机号"
            placeholder="请输入就诊卡预留手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请输入手机号' },
              { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
            ]"
          >
            <template #label>
              <span class="required-star">*</span>手机号
            </template>
          </van-field>
          
          <van-field
            v-model="queryForm.verifyCode"
            name="verifyCode"
            label="验证码"
            placeholder="请输入验证码"
            maxlength="6"
            :rules="[{ required: true, message: '请输入验证码' }]"
          >
            <template #label>
              <span class="required-star">*</span>验证码
            </template>
            <template #button>
              <div 
                class="verify-code-btn" 
                :class="{ 'disabled': countdown > 0 }"
                @click="sendVerifyCode"
              >
                {{ codeButtonText }}
              </div>
            </template>
          </van-field>
          
          <div class="submit-section">
            <van-button 
              type="primary" 
              size="large" 
              round 
              block 
              :loading="queryForm.submitting"
              loading-text="查询中..."
              native-type="submit"
              class="query-button"
            >
              查询
            </van-button>
          </div>
        </van-form>
      </div>
    </div>

    <!-- 查询结果弹窗 -->
    <van-dialog
      v-model="showResult"
      title="查询结果"
      :show-cancel-button="false"
      confirm-button-text="确定"
      class="result-dialog"
    >
      <div class="result-content">
        <div v-if="queryResult.success" class="success-result">
          <van-icon name="checked" class="success-icon" />
          <p class="result-message">{{ queryResult.message }}</p>
          <div v-if="queryResult.data" class="result-data">
            <template v-if="queryResult.data.cardList && queryResult.data.cardList.length">
              <div
                class="data-item"
                v-for="(card, index) in queryResult.data.cardList"
                :key="index"
              >
                <div style="flex:1">
                  <div>
                    <span class="data-label">姓名：</span>
                    <span class="data-value">{{ card.name || card.patientName || '-' }}</span>
                  </div>
                  <div>
                    <span class="data-label">卡号：</span>
                    <span class="data-value">{{ card.cardNo || card.hisCardNo || '-' }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="data-item">
                <span class="data-label">提示：</span>
                <span class="data-value">未找到相关卡片记录</span>
              </div>
            </template>
          </div>
        </div>
        <div v-else class="error-result">
          <van-icon name="close" class="error-icon" />
          <p class="result-message">{{ queryResult.message }}</p>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'HospitalQuery',
  data() {
    return {
      // 统一查询表单
      queryForm: {
        name: '',
        idCard: '',
        phone: '',
        verifyCode: '',
        submitting: false
      },
      // 验证码相关
      codeButtonText: '获取验证码',
      countdown: 0,
      // 查询结果
      showResult: false,
      queryResult: {
        success: false,
        message: '',
        data: null
      }
    }
  },
  created() {
    // 页面初始化时可以添加其他逻辑
  },
    methods: {
    async sendVerifyCode() {
      if (this.countdown > 0) return
      
      if (!this.queryForm.name) {
        this.$toast('请先输入姓名')
        return
      }
      
      if (!this.queryForm.phone) {
        this.$toast('请先输入手机号')
        return
      }
      
      if (!/^1[3-9]\d{9}$/.test(this.queryForm.phone)) {
        this.$toast('请输入正确的手机号')
        return
      }
      
      try {
        // 调用发送验证码接口（仅需手机号）
        const resMsg = await this.$http.post(this.$api.SEND_VERIFY_CODE, {
          phone: this.queryForm.phone
        })

        this.$toast.success(typeof resMsg === 'string' ? resMsg : '验证码发送成功')
        this.startCountdown()
      } catch (error) {
        console.error('发送验证码失败:', error)
        this.$toast.fail('验证码发送失败，请稍后重试')
      }
    },
    
    // 开始倒计时
    startCountdown() {
      this.countdown = 60
      this.codeButtonText = `${this.countdown}s后重新发送`
      
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown > 0) {
          this.codeButtonText = `${this.countdown}s后重新发送`
        } else {
          this.codeButtonText = '获取验证码'
          clearInterval(timer)
        }
      }, 1000)
    },
    
    // 统一查询提交（验证码查询卡列表）
    async onSubmitQuery() {
      this.queryForm.submitting = true

      // 简单前端校验（防止直接触发）
      if (!this.queryForm.name || !this.queryForm.phone || !this.queryForm.verifyCode) {
        this.$toast('请完整填写信息')
        this.queryForm.submitting = false
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.queryForm.phone)) {
        this.$toast('请输入正确的手机号')
        this.queryForm.submitting = false
        return
      }

      try {
        // 调用退款查询接口（非 /rest 路径）
        const response = await this.$http.post(this.$api.QUERY_CARD_LIST_BY_SMSCODE, {
          idNo: this.queryForm.idCard,
          idType: '01',
          userName: this.queryForm.name,
          phone: this.queryForm.phone,
          smsCode: this.queryForm.verifyCode
        })

        const cardList = Array.isArray(response && response.cardList) ? response.cardList : []

        // 若查询到卡列表则跳转到选择页面，并缓存数据
        if (cardList.length > 0) {
          try {
            sessionStorage.setItem('refundQueryCardList', JSON.stringify(cardList))
            sessionStorage.setItem('refundQueryUserName', this.queryForm.name)
          } catch (e) {}
          this.$router.push({ name: 'onlineRefundSelect', params: { cardList, userName: this.queryForm.name } })
        } else {
          // 无记录则弹窗提示
          this.queryResult = {
            success: true,
            message: '查询成功，暂无卡片记录',
            data: { cardList }
          }
          this.showResult = true
        }

      } catch (error) {
        console.error('查询失败:', error)
        this.queryResult = {
          success: false,
          message: (error && error.message) ? error.message : '查询失败，请确认信息与验证码是否正确',
          data: null
        }
        this.showResult = true
      } finally {
        this.queryForm.submitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.hospital-query {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: .2rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  
  .query-section {
    width: 100%;
    max-width: 500px;
    margin-bottom: 2rem;
    background: white;
    border-radius: 1rem;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    
    &-header {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 1.5rem 1.5rem;
      display: flex;
      align-items: center;
      
      .query-section-indicator {
        width: 4px;
        height: 1.8rem;
        background: white;
        border-radius: 2px;
        margin-right: 1rem;
      }
      
      .query-section-title {
        color: white;
        font-size: 1.2rem;
        font-weight: 600;
        margin: 0;
        line-height: 1.4;
      }
    }
    
    .query-form {
      padding: 1rem 1rem;
      
      .van-form {
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
      }
      
      .van-field {
        margin-bottom: 0;
        border-radius: 0.8rem;
        background: #f8f9ff;
        border: 1px solid rgba(102, 126, 234, 0.1);
        transition: all 0.3s ease;
        min-height: 3.5rem;
        overflow: visible;
        
        &:focus-within {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }
        
        // 身份证输入框特殊样式
        &:nth-child(2) {
          .van-field__control {
            font-size: 1.05rem;
            font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
            letter-spacing: 1px;
            font-weight: 500;
          }
        }
        
        .van-field__control {
          width: 100%;
          min-width: 0;
          flex: 1;
          font-family: 'Courier New', monospace;
          letter-spacing: 0.3px;
          padding: 0.3rem;
          font-size: 0.9rem;
          
          &::placeholder {
            color: #999;
            font-size: 0.85rem;
            font-family: inherit;
            letter-spacing: normal;
          }
        }
        
        /* 移动端验证码输入框优化 */
        .van-field:nth-child(4) {
          .van-field__control {
            font-size: 0.95rem;
            font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
            letter-spacing: 0.8px;
            font-weight: 500;
            min-width: 100px;
            flex: 3;
            padding: 0.4rem;
          }
          
          .van-field__body {
            flex: 3;
            min-width: 0;
          }
        }
        .van-field__label {
          color: #555;
          font-weight: 600;
          font-size: 0.9rem;
          padding: 0 0.5rem;
          min-width: 2.8rem;
          max-width: 3.2rem;
          display: flex;
          align-items: center;
          flex-shrink: 0;
          white-space: nowrap;
        }
        
        .van-field__body {
          padding: 0.8rem 0.3rem;
          display: flex;
          align-items: center;
          flex: 1;
          min-width: 0;
        }
        
        .van-field__right-icon {
          padding-right: 1rem;
          flex-shrink: 0;
          display: flex;
          align-items: center;
        }
        
        .van-field__button {
          padding-left: 0.5rem;
          flex-shrink: 0;
          display: flex;
          align-items: center;
        }
        
        .van-field__clear {
          color: #ccc;
          font-size: 1rem;
        }
      }
      
      .required-star {
        color: #ff6b6b;
        margin-right: 0.3rem;
        font-weight: bold;
      }
      
      .verify-code-btn {
        font-size: 0.75rem;
        color: #667eea;
        font-weight: 600;
        padding: 0.25rem 0.5rem;
        border-radius: 0.6rem;
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
        border: 1px solid rgba(102, 126, 234, 0.3);
        transition: all 0.3s ease;
        cursor: pointer;
        user-select: none;
        white-space: nowrap;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        min-width: 50px;
        max-width: 70px;
        height: 1.6rem;
        line-height: 1;
        flex-shrink: 0;
        &:hover {
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
          border-color: rgba(102, 126, 234, 0.5);
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
        }
        
        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
        }
        
        &.disabled {
          color: #999;
          background: #f5f5f5;
          border-color: #ddd;
          cursor: not-allowed;
          
          &:hover {
            transform: none;
            box-shadow: none;
            background: #f5f5f5;
            border-color: #ddd;
          }
        }
      }
      
      .submit-section {
        margin-top: 2.5rem;
        
        .query-button {
          height: 3.5rem;
          font-size: 1.2rem;
          font-weight: 600;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
          transition: all 0.3s ease;
          border-radius: 1.75rem;
          
          &:active {
            transform: translateY(1px);
            box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
          }
          
          &.van-button--loading {
            background: linear-gradient(135deg, #a8a8a8 0%, #999 100%);
          }
        }
      }
    }
  }
}

// 查询结果弹窗样式
.result-dialog {
  .van-dialog__content {
    padding: 2rem 1.5rem;
  }
  
  .result-content {
    text-align: center;
    
    .success-result {
      .success-icon {
        font-size: 3rem;
        color: #52c41a;
        margin-bottom: 1rem;
      }
    }
    
    .error-result {
      .error-icon {
        font-size: 3rem;
        color: #ff4d4f;
        margin-bottom: 1rem;
      }
    }
    
    .result-message {
      font-size: 1.1rem;
      color: #333;
      margin-bottom: 1.5rem;
      line-height: 1.5;
    }
    
    .result-data {
      background: #f8f9ff;
      border-radius: 0.5rem;
      padding: 1rem;
      text-align: left;
      
      .data-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.5rem 0;
        border-bottom: 1px solid rgba(102, 126, 234, 0.1);
        
        &:last-child {
          border-bottom: none;
        }
        
        .data-label {
          color: #666;
          font-size: 0.9rem;
        }

        .data-value {
          color: #333;
          font-weight: 600;
          font-size: 1rem;
        }
      }
    }
  }
}
</style>